export class User {
  id:string;
  name:string;
  email:string;
  password:string;
  password_repeat:string;
  role:string;
  status:number;
  max_users:number;
  total_users:number;
  timezone:String;
}



// WEBPACK FOOTER //
// /var/www/_deploy/front-company-testing/2018-09-30-21-57-10/src/app/models/user.ts